<template>
  <div class="share-main">
    <div class="stage">
      <div class="editor">
        <div id="spine"></div>
      </div>
    </div>
    <div class="share-guide" v-if="showGuide" @click="showGuide = false">
      <img src="./image/img_guide_share_322_196@2x.png" alt="" />
    </div>
    <div class="make-btn" v-if="showBtn" @click="goWow">我也做一个</div>
  </div>
</template>

<script >
import { DropShadowFilter } from '@pixi/filter-drop-shadow'
require('@/assets/js/share.min.js')
const PIXI = window.PIXI
const _ = require('lodash')
const typeJson = require('@/assets/json/forZpace_en.json')
// const colorJson = require('@/assets/json/color.json')
export default {
  name: 'WowShare',
  data () {
    return {
      id: this.$route.query.id,
      workInfo: null,
      bgList: [],
      contentContain: {},
      personContain: {},
      init_data: {
        x: 400,
        y: 600,
        scale: 0.25,
        stageWidth: 0,
        stageHeight: 0
      },
      bgSprite: null,
      showGuide: false,
      showBtn: false,
      shareData: {
        title: '这是我的WOW人设',
        summary: '快来制作你的二次元人设吧',
        url: window.location.origin +
          window.location.pathname +
          window.location.search + '#/wowShare?id=' + this.$route.query.id,
        pic: 'http://qnp.mindcomic.com/upload/image/60aab27654cc0c0f3f9244a450c24cdf.png'
      }
    }
  },
  components: {},
  computed: {},
  created () {
    if (sessionStorage.getItem('showGuide')) {
      if (!localStorage.getItem('zpace_share_guide')) {
        localStorage.setItem('zpace_share_guide', '1')
        this.showGuide = true
      } else {
        let num = localStorage.getItem('zpace_share_guide') - 0
        if (num < 3) {
          num++
          localStorage.setItem('zpace_share_guide', num)
          this.showGuide = true
        } else {
          this.showGuide = false
        }
      }
    }
  },
  mounted () {
    this.getWorkInfo()
  },
  methods: {
    // 资源初始化
    init () {
      this.init_data.stageWidth = document.querySelector('.editor').clientWidth
      this.init_data.stageHeight = document.querySelector('.editor').clientHeight
      this.init_data.x = this.init_data.stageWidth / 2
      const app = new PIXI.Application({
        width: this.init_data.stageWidth,
        height: this.init_data.stageHeight,
        autoResize: true,
        antialias: true,
        transparent: true,
        resolution: window.devicePixelRatio || 1,
        resizeTo: document.querySelector('.editor')
      })
      // 最大的容器
      this.contentContain = new PIXI.Container()
      // 人物容器
      this.personContain = new PIXI.Container()
      // 背景容器
      this.bgContain = new PIXI.Container()
      this.bgContain.width = this.init_data.stageWidth
      this.bgContain.height = this.init_data.stageHeight

      this.contentContain.interactive = true
      this.contentContain.width = this.init_data.stageWidth
      this.contentContain.height = this.init_data.stageHeight
      this.contentContain.pivot.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.contentContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.contentContain.addChild(this.bgContain)
      this.contentContain.addChild(this.personContain)
      this.contentContain.hitArea = new PIXI.Rectangle(0, 0, this.init_data.stageWidth, this.init_data.stageHeight)
      this.app = app

      this.app.renderer.resize(
        document.querySelector('.editor').clientWidth,
        document.querySelector('.editor').clientHeight
      )
      document.querySelector('#spine').appendChild(app.view)
      this.app.stage.interactive = true
      this.app.stage.buttonMode = true

      this.app.loader
        .add('model', 'spineAssets/mobile/LUOMO.json')
        .add('circle', require('./image/img_control_point@2x.png'))
        .load(this.resLoadHandler)
      this.app.stage.addChild(this.contentContain)
      this.shareInit()
      window.addEventListener('resize', this.resize, false)
    },
    // 自适应
    resize () {
      this.app.resize(document.querySelector('.editor'))
      this.init_data.stageWidth = document.querySelector('.editor').clientWidth
      this.init_data.stageHeight = document.querySelector('.editor').clientHeight
      this.personContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.personContain.y = 3.42 * window.fs
      const scale = (6 * window.fs) / this.Model.spineData.height
      this.init_data.scale = scale
      this.personContain.scale.set(scale)
    },
    async resLoadHandler (loader, resources) {
      // 加载裸模
      this.loadModel(resources.model.spineData)

      // 加载搭配列表
      this.getMatchList(this.workInfo.clothes.my.list)
      // 颜色初始化
      this.colorInit()
      //  加载背景
      if (this.workInfo.camera.bg.active !== '') {
        this.loadBgList()
      }

      const animationName = this.workInfo.camera.animation.active === '' ? '动态_讲话' : this.workInfo['camera'].animation.list[this.workInfo['camera'].animation.active].name
      this.Model.state.setAnimation(0, animationName, true)
      if (!sessionStorage.getItem('showGuide')) {
        setTimeout(() => {
          this.showBtn = true
        }, 3000)
      }
    },
    // 加载初始模型
    loadModel (spineData) {
      this.Model = new PIXI.spine.Spine(spineData)
      this.Model.filters = [new DropShadowFilter(10, 0)]
      window.Model = this.Model
      window.app = this.app
      console.log(this.Model)
      this.Model.x = 0
      this.Model.y = 0
      // 模型原点有问题， 设置为左上角原点
      this.Model.pivot.set(-this.Model.spineData.width / 2, -this.Model.spineData.height)
      // 开启debug
      // this.Model.drawDebug = true
      // this.Model.drawBones = true
      this.personContain.width = this.Model.spineData.width
      this.personContain.height = this.Model.spineData.height
      this.personContain.addChild(this.Model)
      // 设置最外部容器原点为骨骼数据的宽高中点
      this.personContain.pivot.set(this.Model.spineData.width / 2, this.Model.spineData.height / 2)
      // 设置最外部容器 的位置 居中显示
      this.personContain.position.set(this.init_data.stageWidth / 2, this.init_data.stageHeight / 2)
      this.personContain.y = 3.42 * window.fs
      const scale = (6 * window.fs) / this.Model.spineData.height
      this.init_data.scale = scale
      this.scale = scale
      this.personContain.scale.set(scale + 0.02)
      // this.debug()
      this.personContain.interactive = false
    },
    getMatchList (list) {
      console.log(list)
      // 添加资源到pixi 缓存
      list.forEach(item => {
        if (item.type == 'all') {
          item.elements_block.forEach(element => {
            for (const slot in element.elements) {
              this.app.loader.add(`${item.id}_${slot}`, this.constv.QINIU_IMAGE_CND_URL + element.elements[slot])
            }
          })
        } else {
          for (const slot in item.elements) {
            this.app.loader.add(`${item.id}_${slot}`, this.constv.QINIU_IMAGE_CND_URL + item.elements[slot])
          }
        }
      })

      list.forEach(item => {
        if (item.type == 'all') {
          item.elements_block.forEach(element => {
            this.app.loader.load(() => {
              for (const slot in element.elements) {
                const texture = this.app.loader.resources[item.id + '_' + slot].texture
                console.log(this.app.loader.resources, texture, slot)
                if (this.Model.skeleton.findSlot(slot) && this.Model.skeleton.findSlot(slot).attachment) {
                  this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
                }
              }
            })
          })
        } else {
          this.app.loader.load(() => {
            for (const slot in item.elements) {
              const texture = this.app.loader.resources[item.id + '_' + slot].texture
              const currentSlot = this.Model.skeleton.findSlot(slot)
              if (currentSlot && currentSlot.attachment) {
                if (!currentSlot.defaultTexture) {
                  currentSlot.defaultTexture = currentSlot.currentMesh.texture || texture
                }

                this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
              }
            }
          })
        }
      })
    },
    getWorkInfo () {
      this.$api.wow.getWorksInfo({ id: this.id }).then((res) => {
        if (res.status == 'ok') {
          this.$third.get(`${this.constv.QINIU_IMAGE_CND_URL}` + res.data.works_url).then((res) => {
            this.workInfo = res.data
            this.init()
          })
        }
      })
    },
    loadBgList () {
      const videoTexture = PIXI.Texture.from('img/bainian.mp4')

      const videoSource = videoTexture.baseTexture.source

      this.bgSprite = new PIXI.Sprite(videoTexture)
      const width = 750
      const height = 1000
      console.log(this.bgSprite)
      this.bgSprite.height = height / (width / this.init_data.stageWidth)
      this.bgSprite.width = this.init_data.stageWidth
      this.bgContain.addChild(this.bgSprite)
      setTimeout(() => {
        videoSource.play()
      }, 300)
    },
    colorInit () {
      this.workInfo.clothes.eyes.colorInfo.activeColor && typeJson.colorCtrl['eyes'].forEach((slot) => {
        const activeSlot = this.Model.skeleton.findSlot(slot)

        if (activeSlot && activeSlot.attachment) {
          if (!activeSlot.defaultTexture) {
            if (activeSlot.currentMesh.texture) {
              activeSlot.defaultTexture = activeSlot.currentMesh.texture
            } else {
              console.log('没有当前插槽贴图')
            }
          }
          const { width, height } = activeSlot.defaultTexture
          const pixel = this.app.renderer.plugins.extract.pixels(new PIXI.Sprite(activeSlot.defaultTexture))
          const color = this.workInfo.clothes.eyes.colorInfo.list[this.workInfo.clothes.eyes.colorInfo.activeColor]
          this.hsvTransform(pixel, color).then((res) => {
            const texture = new PIXI.Texture.fromBuffer(res, width, height)

            this.Model.hackTextureBySlotName(slot, texture, { width: texture.width, height: texture.height })
          })
        } else {
          console.log('替换颜色没找到对应插槽' + slot)
        }
      })

      // 头发颜色
      typeJson.colorCtrl['hair'].forEach((slot) => {
        const activeSlot = this.Model.skeleton.findSlot(slot)
        if (activeSlot) {
          const rgb = this.workInfo.clothes.hair.colorInfo.activeColor
          if (rgb) {
            activeSlot.color.r = rgb[0]
            activeSlot.color.g = rgb[1]
            activeSlot.color.b = rgb[2]
          }
        }
      })

      // 皮肤颜色
      typeJson.colorCtrl['skin'].forEach((slot) => {
        const activeSlot = this.Model.skeleton.findSlot(slot)
        if (activeSlot) {
          const rgb = this.workInfo.clothes.skin.colorInfo.activeColor
          console.log(rgb, 'rgb')
          if (rgb) {
            activeSlot.color.r = rgb[0]
            activeSlot.color.g = rgb[1]
            activeSlot.color.b = rgb[2]
          }
        }
      })
    },
    async hsvTransform (pixel, item) {
      return new Promise(async (resolve, reject) => {
        for (let i = 0; i < pixel.length; i += 4) {
          // 灰度处理
          const r = pixel[i]
          const g = pixel[i + 1]
          const b = pixel[i + 2]
          pixel[i] = r * 0.3 + g * 0.59 + b * 0.11
          pixel[i + 1] = r * 0.3 + g * 0.59 + b * 0.11
          pixel[i + 2] = r * 0.3 + g * 0.59 + b * 0.11
        }
        const hsv = new Float32Array(pixel.length / 4)
        // rgb转hsv
        for (let i = 0; i < pixel.length; i += 4) {
          const r = pixel[i]
          const g = pixel[i + 1]
          const b = pixel[i + 2]
          const tump = this.rgb2hsv(r, g, b)

          hsv[i / 4] = tump[2] * 100
        }
        const colorCanvas = this.getImageData(item)
        const ctx = colorCanvas.getContext('2d')

        var colorIndex = colorCanvas.width / 100
        // 映射关系
        for (let i = 0, j = 0; i < hsv.length; i++, j += 4) {
          const v = hsv[i]

          const cindex = Math.floor(v * colorIndex)

          var tststpixel = ctx.getImageData(cindex - 1, 1, 1, 1)
          const [r, g, b] = tststpixel.data
          pixel[j] = r
          pixel[j + 1] = g
          pixel[j + 2] = b
        }
        resolve(pixel)
      })
    },
    getImageData (item) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      var gradient = ctx.createLinearGradient(0, 0, 100, 0)
      canvas.width = 100
      canvas.height = 25
      item = _.orderBy(item, ['stop'], ['asc'])
      item.forEach(part => {
        gradient.addColorStop(part.stop / 100, part.rgba)
      })
      ctx.fillStyle = gradient
      ctx.fillRect(0, 0, 100, 25)
      return canvas
    },
    rgb2hsv (r, g, b) {
      var computedH = 0
      var computedS = 0
      var computedV = 0

      // remove spaces from input RGB values, convert to int
      r = parseInt(('' + r).replace(/\s/g, ''), 10)
      g = parseInt(('' + g).replace(/\s/g, ''), 10)
      b = parseInt(('' + b).replace(/\s/g, ''), 10)

      if (r == null || g == null || b == null || isNaN(r) || isNaN(g) || isNaN(b)) {
        alert('Please enter numeric RGB values!')
        return
      }
      if (r < 0 || g < 0 || b < 0 || r > 255 || g > 255 || b > 255) {
        alert('RGB values must be in the range 0 to 255.')
        return
      }
      r = r / 255
      g = g / 255
      b = b / 255
      var minRGB = Math.min(r, Math.min(g, b))
      var maxRGB = Math.max(r, Math.max(g, b))

      // Black-gray-white
      if (minRGB == maxRGB) {
        computedV = minRGB
        return [0, 0, computedV]
      }
      // Colors other than black-gray-white:
      var d = r == minRGB ? g - b : b == minRGB ? r - g : b - r
      var h = r == minRGB ? 3 : b == minRGB ? 1 : 5
      computedH = 60 * (h - d / (maxRGB - minRGB))
      computedS = (maxRGB - minRGB) / maxRGB
      computedV = maxRGB
      return [computedH, computedS, computedV]
    },
    shareInit () {
      window.chumanShare.init({
        title: this.shareData.title,
        summary: this.shareData.summary,
        pic: this.shareData.pic,
        url: this.shareData.url
      })
    },
    goWow () {
      this.$router.push({
        path: '/wow'
      })
    }
  }
}
</script>

<style lang='less' scoped>
.share-main {
  position: relative;
  .make-btn {
    position: absolute;
    left: 50%;
    top: 10.48rem;
    transform: translateX(-50%);
    width: 2.8rem;
    height: 0.72rem;
    border-radius: 0.4rem;
    background-color: #ff7401;
    color: #ffffff;
    font-size: 0.32rem;
    line-height: 0.72rem;
    text-align: center;
    margin: 0 auto 0;
  }
  .share-guide {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.5);
    img {
      display: block;
      width: 100%;
      height: auto;
      margin-top: 0.32rem;
      width: 6.4rem;
      height: 3.92rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .stage {
    width: 100%;
    height: 100%;
    background-color: #f2f5f7;
    background-size: 100% auto;
    background-repeat: no-repeat;
    .editor {
      width: 100vw;
      height: 100vh;
    }
  }
}
</style>
